module.exports = __webpack_public_path__ + "media/img/chat-window-f793ddf84f6412ee9c326e417eb60071.jpg";